import { SagaIterator } from "redux-saga";
import { all, call, fork, select, takeEvery } from "redux-saga/effects";

import Role from "constants/role";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { IAgent } from "store/entities/agents";
import { selectLoggedInAgent } from "store/entities/agents/selectors";
import { removeEmptyProps } from "utils/object";

import {
  EventTrackingAction,
  EventTrackingActionNames,
  ICustomEventProperties,
  IEventTrackingPayload,
  IGlobalEventTrackingPayload,
} from "./actions";
import { eventPlaceToPrefix } from "./helpers";

function* track(eventName: string, eventProperties?: ICustomEventProperties, eventPlace?: EventPlace): SagaIterator {
  const agent: IAgent = yield select(selectLoggedInAgent);
  const permission: Role = agent && agent.permission;
  const fullProperties: ICustomEventProperties = { permission, ...eventProperties };

  // @ts-expect-error TS(2769)
  yield call(trackEngagement, eventName, eventPlace, removeEmptyProps(fullProperties), true);
}

function* trackGlobalEvent(action: EventTrackingAction): SagaIterator {
  const { eventName, eventProperties } = action.payload as IGlobalEventTrackingPayload;
  yield fork(track, eventName, eventProperties);
}

function* trackEvent(action: EventTrackingAction): SagaIterator {
  const { eventName, eventPlace, eventProperties, ownPrefix } = action.payload as IEventTrackingPayload;
  const prefix: string = ownPrefix || eventPlaceToPrefix(eventPlace);
  yield fork(track, `${prefix}: ${eventName}`, eventProperties, eventPlace);
}

function* watchTrackGlobalEvent(): SagaIterator {
  yield takeEvery(EventTrackingActionNames.TRACK_GLOBAL_EVENT, trackGlobalEvent);
}

function* watchTrackEvent(): SagaIterator {
  yield takeEvery(EventTrackingActionNames.TRACK_EVENT, trackEvent);
}

export function* eventTrackingSagas(): SagaIterator {
  yield all([fork(watchTrackGlobalEvent), fork(watchTrackEvent)]);
}
